export enum DetailPageViewMode {
    List = 'list',
    Tabs = 'tabs',
}
